const TableBlock = ({ block }) => {
  const content = block.content;

  return (
    <div className="table-block-container">
      <table className="table-block">
        <thead className="table-block-header">
          <tr>
            {content.headers.map((header, index) => (
              <th key={`header-${index}`} className="table-block-header-cell">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {content.rows.map((row, rowIndex) => (
            <tr key={`row-${rowIndex}`} className="table-block-row">
              {row.map((cell, cellIndex) => (
                <td key={`cell-${rowIndex}-${cellIndex}`} className="table-block-cell">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableBlock;